@if (!embedded) {
  <app-navbar></app-navbar>
}
<div [class]="embedded ? '' : 'container-fluid mt-4'">
  @if (!embedded) {
    <a routerLink="/admin" class="back-link"><i class="bi bi-arrow-left"></i> Back to Admin</a>
    <h2 class="mb-4"><i class="bi bi-book me-2"></i> Courses</h2>
  }
  <div class="card">
    <div class="card-body">
      <div class="d-flex flex-wrap align-items-center gap-3 mb-3">
        <label class="text-muted mb-0">Seed:</label>
        <select class="form-select" style="width: auto; min-width: 10rem; max-width: 18rem" [ngModel]="selectedSeedId" (ngModelChange)="selectedSeedId = $event; onSeedChange()">
          @for (s of seeds; track s.id) {
            <option [ngValue]="s.id">{{ s.name }}</option>
          }
        </select>
        <button type="button" class="btn btn-primary ms-auto" (click)="openCreate()">Create Course</button>
      </div>
      @if (error) {
        <div class="alert alert-danger">{{ error }}</div>
      }
      @if (message) {
        <div class="alert alert-success">{{ message }}</div>
      }
      @if (loading) {
        <p class="text-muted">Loading…</p>
      } @else {
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th (click)="setSort('name')" class="sortable"><span class="me-1">Name</span><i [class]="'bi ' + sortIcon('name')"></i></th>
                <th (click)="setSort('active')" class="sortable"><span class="me-1">Active</span><i [class]="'bi ' + sortIcon('active')"></i></th>
                <th (click)="setSort('seedId')" class="sortable"><span class="me-1">Seed</span><i [class]="'bi ' + sortIcon('seedId')"></i></th>
                <th (click)="setSort('createdAt')" class="sortable"><span class="me-1">Created</span><i [class]="'bi ' + sortIcon('createdAt')"></i></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (c of sortedContent; track c.id) {
                <tr class="clickable-row" (click)="openEdit(c)" role="button" tabindex="0">
                  <td>{{ c.name }}</td>
                  <td>{{ c.active ? 'Yes' : 'No' }}</td>
                  <td>{{ seedName(c.seedId) }}</td>
                  <td>{{ c.createdAt ?? '—' }}</td>
                  <td (click)="$event.stopPropagation()">
                    <button type="button" class="btn btn-sm btn-outline-danger" (click)="openDeleteConfirm(c)" >Delete</button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (sortedContent.length === 0) {
          <p class="text-muted mb-0">No courses.</p>
        }
      }
    </div>
  </div>
</div>

@if (detailItem) {
  <div class="modal show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ detailItem.id == null ? 'Create course' : 'Edit course' }}</h5>
          <button type="button" class="btn-close" (click)="closeDetail()"></button>
        </div>
        <div class="modal-body">
          <div class="mb-2">
            <label class="form-label">Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="detailForm.name" placeholder="Course name">
          </div>
          <div class="form-check mb-2">
            <input type="checkbox" class="form-check-input" id="detailActive" [ngModel]="detailForm.active === 1" (ngModelChange)="detailForm.active = $event ? 1 : 0">
            <label class="form-check-label" for="detailActive">Active</label>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeDetail()">Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="detailSaving" (click)="save()">Save</button>
        </div>
      </div>
    </div>
  </div>
}

@if (deleteItem) {
  <div class="modal show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Delete course</h5>
          <button type="button" class="btn-close" (click)="closeDeleteConfirm()"></button>
        </div>
        <div class="modal-body">
          @if (deleteError) {
            <div class="alert alert-danger">{{ deleteError }}</div>
          }
          <p>Delete course <strong>{{ deleteItem.name }}</strong>? This cannot be undone.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeDeleteConfirm()">Cancel</button>
          <button type="button" class="btn btn-danger" (click)="confirmDelete()" >Delete</button>
        </div>
      </div>
    </div>
  </div>
}
